import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
export const ProductCard = ({ servicelink, serviceimage, cardtitle, description }) => {
  return (
    <div className="product-carousel-card">
      <Link to={servicelink} className="product-card-link">

        {/* Product Image */}
        <img src={serviceimage} alt={cardtitle} />

        {/* Product Details */}
        <div className="product-card-content">
          <h3 className="product-card-title">{cardtitle}</h3>
          {description && <p className="product-card-description">{description}</p>}

        </div>
      </Link>
    </div >
  );
};

// PropTypes for type-checking
ProductCard.propTypes = {
  servicelink: PropTypes.string.isRequired, // The URL link to the product details page
  serviceimage: PropTypes.string.isRequired, // The image URL or path for the product
  cardtitle: PropTypes.string.isRequired, // The title or name of the product
  description: PropTypes.string, // Optional: A short description of the product
};

// Default Props
ProductCard.defaultProps = {
  description: "", // Default to an empty string if no description is provided
};
